/**
 * A global namespace for `focus` event.
 * @type {string}
 */
const focusEvent = 'focus';
export default focusEvent;
